import { render, staticRenderFns } from "./ChatManagementComputerView.vue?vue&type=template&id=26a802d9&scoped=true"
import script from "./ChatManagementComputerView.vue?vue&type=script&lang=js"
export * from "./ChatManagementComputerView.vue?vue&type=script&lang=js"
import style0 from "./ChatManagementComputerView.vue?vue&type=style&index=0&id=26a802d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a802d9",
  null
  
)

export default component.exports